export default "__VITE_ASSET__BhX8mT5B__"